module.exports = __webpack_public_path__ + "media/images/athletes/2631-cb98bc87ff270c5ad112f21e08a296c7.png";